var render = function (_h,_vm) {var _c=_vm._c;return _c('b-modal',{attrs:{"id":"error-modal","content-class":"bg-dark","title":"Error","title-tag":"h4","header-text-variant":"danger","ok-title":"Close","ok-variant":"danger","ok-only":true,"centered":""}},[_c('div',{staticClass:"text-danger"},[_vm._t("error-message")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }